var default_styles_default = {
  "button_container": "hXcCe",
  "button_margin": "_982jM",
  "button_text": "v1Ct4",
  "button_size_content": "-XznE"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
